import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import FireReactionShape from '@/components/common/svg/shapes/FireReactionShape.tsx';

interface PremiumButtonProps {
  onClick?: () => void;
}

const PAGE_BG = 'rgb(245, 245, 245)';

const SentLikesListBanner = ({ onClick }: PremiumButtonProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div style={stickyTitleStyle}>
        <div style={titleStyle}>{t('sent_likes.banner.title')}</div>
      </div>

      <div style={subtitleStyle}>{t('sent_likes.banner.subtitle')}</div>

      <div style={stickyButtonStyle}>
        <motion.div
          whileTap={{ scale: 0.97 }}
          style={buttonInnerStyle}
          onClick={onClick}
        >
          <FireReactionShape
            fillColor="#fff"
            width={20}
            height={20}
            style={{ marginRight: '5px' }}
          />
          <span style={textStyle}>{t('sent_likes.banner.btn')}</span>
        </motion.div>
      </div>
    </>
  );
};

const stickyTitleStyle: CSSProperties = {
  position: 'sticky',
  top: -15,
  zIndex: 10,
  background: PAGE_BG,
  padding: '8px 0 4px',
  width: '100%'
};

const titleStyle: CSSProperties = {
  fontSize: '16px',
  fontWeight: 590,
  color: '#000',
  textAlign: 'left'
};

const subtitleStyle: CSSProperties = {
  fontSize: '12px',
  fontWeight: 510,
  color: '#787878',
  textAlign: 'left',
  padding: '2px 0',
  width: '100%'
};

const stickyButtonStyle: CSSProperties = {
  position: 'sticky',
  top: 13,
  zIndex: 9,
  background: PAGE_BG,
  paddingBottom: 12,
  width: '100%',
  display: 'flex',
  justifyContent: 'center'
};

const buttonInnerStyle: CSSProperties = {
  width: '100%',
  height: '41px',
  borderRadius: '100px',
  display: 'flex',
  marginTop: '10px',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(90deg, #FDCB40 0%, #FFA100 100%)',
  cursor: 'pointer'
};

const textStyle: CSSProperties = {
  fontSize: '15px',
  color: '#FFF',
  fontWeight: 590,
  letterSpacing: '0.5px'
};

export default SentLikesListBanner;
